import { loadingDotsImage } from './constants';
export default class IframeHandler {
  constructor(id, src, getIframeHeight, visible, iframeOptions = {}) {
    this.iframe = document.createElement('iframe');
    this.img = null;
    this.addFrameStyles = () => {
      if (this.iframeOptions.style) {
        Object.entries(this.iframeOptions.style).forEach(([key, value]) => {
          this.iframe.style[key] = value;
        });
      }
    };
    this.id = id;
    this.src = src;
    this.getIframeHeight = getIframeHeight;
    this.iframeOptions = iframeOptions;
    this.createIframeElement(visible);
  }
  addIframeResizeEvent(iframe) {
    if (this.iframeOptions.autoResize) {
      return;
    }
    let animationFrame;
    window.addEventListener('resize', () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
      animationFrame = requestAnimationFrame(() => {
        iframe.style.minHeight = `${this.getIframeHeight()}px`;
      });
    }, true);
  }
  createIframeElement(visible = true) {
    this.iframe.id = this.id;
    this.iframe.src = this.src;
    this.iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    this.iframe.setAttribute('data-test-id', `${this.id}-iframe`);
    this.iframe.setAttribute('allow', 'clipboard-write');
    this.iframe.setAttribute('sandbox', 'allow-scripts allow-forms allow-popups allow-top-navigation allow-same-origin');
    if (visible) {
      this.iframe.style.minHeight = `${this.getIframeHeight()}px`;
      this.addIframeResizeEvent(this.iframe);
      this.iframe.width = '100%';
      this.addFrameStyles();
    } else {
      this.iframe.style.display = 'none';
    }
  }
  removeLoader() {
    if (this.img) {
      this.img.remove();
      this.img = null;
    }
  }
  createLoadingDotsImage() {
    const img = document.createElement('img');
    img.src = loadingDotsImage;
    img.id = 'hs-plugin-loader';
    img.style.cssText = ` top: 50%;
                        left: 50%;
                        margin-left: -41px;
                        margin-top: -37;
                        display: block;
                        position: absolute;
                        z-index: 900;`;
    return img;
  }
  withLoadingSpinner() {
    const iframeContainer = document.createElement('div');
    this.img = this.createLoadingDotsImage();
    iframeContainer.appendChild(this.img);
    iframeContainer.appendChild(this.iframe);
    return iframeContainer;
  }
  getIframe() {
    return this.iframe;
  }
}